export default __webpack_public_path__ + "static/media/brazil.8506e175.svg";